import styles from './filled-button.module.scss';

interface FilledButtonProps {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
}

const FilledButton: React.FC<FilledButtonProps> = ({children, className, onClick, ...props}) => {
    return (
        <div className="perspective">
            <button className={`${styles.buttonFilled} ${className}`} onClick={onClick} {...props}>
                {children}
            </button>
        </div>
    );
};

export {FilledButton};
